import { render, staticRenderFns } from "./SettingView.vue?vue&type=template&id=5b2b1569&scoped=true&"
import script from "./SettingView.vue?vue&type=script&lang=js&"
export * from "./SettingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2b1569",
  null
  
)

export default component.exports